import { render, staticRenderFns } from "./SendCertificate.vue?vue&type=template&id=651b66f1&scoped=true"
import script from "./SendCertificate.vue?vue&type=script&lang=js"
export * from "./SendCertificate.vue?vue&type=script&lang=js"
import style0 from "./SendCertificate.vue?vue&type=style&index=0&id=651b66f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651b66f1",
  null
  
)

export default component.exports